import React from 'react';
import styled from 'styled-components';
import { QUICK_REPLIES } from './data/quickReplies';

// Renderizado dentro da conversa (topo), então é transparente e sem bordas de "barra".
const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 0 4px;
`;

const Chip = styled.button`
  padding: 10px 14px;
  border-radius: 9999px;
  border: 1.5px solid ${(p) => p.theme.colors.lightBlue};
  background: ${(p) => p.theme.colors.lightBlue};
  color: ${(p) => p.theme.colors.primary};
  font-family: ${(p) => p.theme.fonts.primary};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #c7dbfb;
  }
  &:focus-visible {
    outline: 3px solid ${(p) => p.theme.colors.info};
    outline-offset: 2px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Botões de perguntas prontas — ajudam quem tem dificuldade de digitar.
const AleQuickReplies = ({ onSelect, disabled }) => {
  return (
    <Wrap aria-label="Perguntas rápidas">
      {QUICK_REPLIES.map((q) => (
        <Chip key={q.id} type="button" onClick={() => onSelect(q)} disabled={disabled}>
          {q.label}
        </Chip>
      ))}
    </Wrap>
  );
};

export default AleQuickReplies;
